export default [
  {
    path: '/dispatch-configurations',
    name: 'dispatch-configurations',
    component: () => import('@/views/dispatch-configurations/pages/List.vue'),
    meta: {
      resource: 'dispatch-configurations',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Dispatch Configurations',
      breadcrumb: [
        {
          text: 'Dispatch Configurations',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dispatch-configurations/new',
    name: 'dispatch-configurations-new',
    component: () => import('@/views/dispatch-configurations/pages/AddDispatchConfig.vue'),
    meta: {
      resource: 'dispatch-configurations',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'New Dispatch Configuration',
      breadcrumb: [
        {
          text: 'Dispatch Configurations',
          to: '/dispatch-configurations',
        },
      ],
    },
  },
  {
    path: '/dispatch-configurations/edit/:id',
    name: 'dispatch-configurations-edit',
    component: () => import('@/views/dispatch-configurations/pages/EditDispatchConfig.vue'),
    meta: {
      resource: 'dispatch-configurations',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Edit Dispatch Configuration',
      breadcrumb: [
        {
          text: 'Dispatch Configurations',
          to: '/dispatch-configurations',
        },
      ],
    },
  },
]
